import React from 'react';
import classNames from 'classnames';
import cls from './TasksBlock.module.css';
import { useTasksBlock } from './useTasksBlock';
import { TasksContainer } from './UI/TasksContainer/TasksContainer';
import { TaskCardList } from './UI/TaskCardList/TaskCardList';

interface TasksBlockProps {
    classes?: string;
}

export const TasksBlock = ({ classes }: TasksBlockProps) => {
    const { types } = useTasksBlock();

    return (
        <div className={classNames(cls.TasksBlock, [classes])}>
            {types.map((type, index) => (
                <TasksContainer key={index} type={type}>
                    <TaskCardList type={type} />
                </TasksContainer>
            ))}
        </div>
    );
};
